import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import {
  FormGroup,
  FormControl,
  Modal,
  Button
} from 'react-bootstrap';
import { url } from '../../../../config';

// Locale
import messages from '../../../../locale/jsonMessages';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import cs from '../../../commonStyle.css';
import s from './ExportCalendar.css';
class ExportCalendar extends React.Component {
  static propTypes = {
    showModal: PropTypes.bool.isRequired,
    close: PropTypes.any.isRequired,
    listId: PropTypes.number.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      value: 'Copy Link',
      copied: false,
    };
    this.copyText = this.copyText.bind(this);
  }

  async copyText() {
    this.setState({
      value: 'Link Copied',
      copied: true
    })
    setTimeout(() => {
      this.setState({
        value: 'Copy Link',
        copied: false
      })
    }, 1000)
  }

  render() {
    const { showModal, close, listId } = this.props;
    const { value } = this.state;
    const calendarURL = url + '/export-calendar?id=' + listId;

    return (
      <Modal show={showModal} onHide={close} animation={false} dialogClassName='commonModalContainer globalModalContainer'>
        <Modal.Header className='commonModalHeader' closeButton>
          <Modal.Title className='commonModalTitle'><FormattedMessage {...messages.exportCalendarLabel} /></Modal.Title>
        </Modal.Header>
        <Modal.Body bsClass='commonModalBody'>
          <form>
            <p className={cx(s.introText, cs.commonMediumText, cs.spaceBottom3)}>
              <FormattedMessage {...messages.exportCalendarLabelDesc1} />
            </p>
            <FormGroup className={cs.noMargin}>
              <label className='commonLabelText'><FormattedMessage {...messages.linkText} /></label>
              <FormControl
                name="url"
                type="text"
                value={calendarURL}
                className='commonInputField'
                readOnly
              />
            </FormGroup>
            <div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
              <Button
                className={cs.btnPrimary}
                type="button"
              // disabled={submitting}
              // onClick={this.submitForm}
              >
                <span className={s.copyLink}>
                  <CopyToClipboard
                    text={calendarURL}
                    onCopy={() => this.copyText()}
                  >
                    <span>
                      {value}
                    </span>
                  </CopyToClipboard>
                </span>
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapState = (state) => ({
});

const mapDispatch = {
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(ExportCalendar)));
